import { styled } from "@mui/system"
import BlurredBackgroundImage from "components/common/BlurredBackgroundImage"
import { _Container, _Content, _BaseText } from "components/sessions/SessionStage"
import React from "react"

interface SessionNoStageProps {
  imageSrc: string
  className?: string
}

const SessionNoStage = (props: SessionNoStageProps) => {
  const { className, imageSrc } = props
  return (
    <_Container ratio={69 / 41} className={className}>
      <BlurredBackgroundImage imageSrc={imageSrc}>
        <_Content>
          <_WelcomeText>Welcome to Stage!</_WelcomeText>
          <_HelpText>
            There is nothing happening on the stage at the moment. Please see below for full
            schedule.
          </_HelpText>
        </_Content>
      </BlurredBackgroundImage>
    </_Container>
  )
}

export default SessionNoStage

const _WelcomeText = styled(_BaseText)(({ theme }) => ({
  ...theme.fonts.raleway500,
  fontSize: "36px",
  lineHeight: "42px",
})) as typeof _BaseText

const _HelpText = styled(_BaseText)(({ theme }) => ({
  paddingTop: "40px",
  ...theme.fonts.lato400,
  fontSize: "16px",
  lineHeight: "22px",
})) as typeof _BaseText
